<template>
  <Popup v-model='visible' panelClass='subscribe-panel'>
    <div class="debug-banner" data-debug="subscribe">
      <div><strong>[SUBSCRIBE DEBUG]</strong></div>
      <div>source exists: {{ !!source }}</div>
      <div>source keys: {{ source ? Object.keys(source).join(', ') : 'n/a' }}</div>
      <div>source.blocks type: {{ typeof source?.blocks }}</div>
      <div>source.blocks length: {{ source?.blocks?.length ?? 'n/a' }}</div>
      <div>source.blocks preview: {{ (typeof source?.blocks === 'string' ? source.blocks.slice(0,200) : JSON.stringify(source?.blocks)?.slice(0,200)) || 'EMPTY' }}</div>
      <div>parseOk: {{ parseState.ok }}</div>
      <div>parseError: {{ parseState.error }}</div>
      <div>parsed count: {{ Array.isArray(parseState.value) ? parseState.value.length : 'not-array' }}</div>
      <div>parsed types: {{ Array.isArray(parseState.value) ? parseState.value.map(b => b?.type).join(', ') : 'n/a' }}</div>
      <div>visible: {{ visible }}</div>
      <div>dismissed cookie: {{ dismissed }}</div>
    </div>
    <Blocks v-if='source.blocks' :content='JSON.parse(source.blocks)' />
  </Popup>
</template>

<script setup>
  import { ref, computed, watch, onMounted } from 'vue'
  import { useCookies } from "vue3-cookies";
  import Popup from './Popup.vue'
  import Blocks from './Blocks.vue'

  const { cookies } = useCookies();
  const props = defineProps(['source']);

  const closed = ref(false);
  const dismissed = computed(() => cookies.get('dismissed') === 'true');

  const visible = computed({
    get: () => !closed.value && !dismissed.value,
    set: () => {
      closed.value = true;
      cookies.set('dismissed', 'true');
    }
  });

  const _describe = (s) => ({
    sourceExists: !!s,
    sourceKeys: s ? Object.keys(s) : null,
    blocksType: typeof s?.blocks,
    blocksLength: s?.blocks?.length ?? null,
    blocksPreview: typeof s?.blocks === 'string' ? s.blocks.slice(0, 140) : s?.blocks,
  });

  const parseState = computed(() => {
    const raw = props.source?.blocks;
    if (!raw) return { ok: false, error: 'source.blocks is ' + String(raw), value: null };
    if (typeof raw !== 'string') return { ok: true, error: null, value: raw };
    try {
      return { ok: true, error: null, value: JSON.parse(raw) };
    } catch (e) {
      return { ok: false, error: e.message, value: null };
    }
  });

  onMounted(() => {
    console.log('[SUBSCRIBE] mounted. dismissed=', dismissed.value, 'visible=', visible.value);
    console.log('[SUBSCRIBE] source snapshot:', _describe(props.source));
    if (props.source?.blocks && typeof props.source.blocks === 'string') {
      try {
        const parsed = JSON.parse(props.source.blocks);
        console.log('[SUBSCRIBE] parsed blocks count:', parsed.length, 'types:', parsed.map(b => b?.type));
      } catch (e) {
        console.error('[SUBSCRIBE] JSON.parse failed:', e.message);
      }
    }
  });

  watch(() => props.source, (s) => {
    console.log('[SUBSCRIBE] source changed:', _describe(s));
  }, { deep: true });
</script>

<style>
  .subscribe-panel {
    width: 27rem;
    bottom: 3rem;
    right: 2rem;
    padding: 2rem 3rem 3rem;
    background-color: rgba(255, 176, 5, 0.9);
    border-radius: 2rem;
    border: 1px solid var(--border);
    box-shadow: 0 0.25rem 0.5rem var(--blueopacity);
    overflow: hidden;
    text-align: left;
  }
</style>
